module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.header.hello1")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.header.hello2")))]), _vm._v(" "), _c('img', {
    staticClass: "mini-qrcode",
    attrs: {
      "src": "https://static3.freshin.online/sku/jcjUHPoDuNxfBBxMMxyjXZfTvIQ%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.header.hello3")))])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('div', {
    staticClass: "main-top"
  }, [_c('ul', {
    staticClass: "main-top-ul"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/NZN7P9JcJvvuy-OPzCCounuIDmc%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-top-li1")))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/im7HpeXJnJZZpZp9v9yU%2B2Lxl7M%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-top-li2")))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/rRpHnA1VvKwDPoQTRIMrgVmUJsg%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-top-li3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle"
  }, [_c('section', {
    staticClass: "main-middle-block"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.title")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.subtitle")))]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.p3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text order-first"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product2.p2")))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "main-middle-block"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.title")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.subtitle")))]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.p3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text order-first"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.p3")))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "main-middle-block"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.title")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.subtitle")))]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.p3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text order-first"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.p3")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-bottom"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "main-bottom-bro"
  }, [_c('h1', [_vm._v("合作伙伴")]), _vm._v(" "), _vm._l((_vm.broList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.broNavActive == index),
        expression: "broNavActive==index"
      }],
      key: index,
      staticClass: "main-bottom-bro-main"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])
  }), _vm._v(" "), _c('ul', {
    staticClass: "main-bottom-bro-ul"
  }, _vm._l((_vm.broNavList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        broNavListActive: _vm.broNavActive == index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeindex(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])])
  }), 0)], 2)])]), _vm._v(" "), _c('footers', {
    attrs: {
      "showMore": "true"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/KAno-d5mTEPiqYhD%2B%2B9SiCKdc9c%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/tVD-Di6k8bZkFOf36V2Fqdy%2B22g%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/Pb0wJwR%2BILGL2aYjsBGCMFe2bhA%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/xEsHmNCOy9wpWvutvGDFUn-iplU%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/IZyNPgBTIY-NlKwewII2o8eB9JI%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/n4UN%2BtHBMld0N2UmrjYOn1buvnU%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("鲜入为主深耕全球优质供应链，精选上千款生鲜产品")]), _vm._v(" "), _c('h1', [_vm._v("致同样在用心生活的你")]), _vm._v(" "), _c('div', {
    staticClass: "main-bottom-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/OlqWDB6hfyAolhCLLx%2BKbsjLbiU%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/QeY02TP1AdQgYbz4soyRfiPbqbs%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/NFluZ2VeF2dbHiJDTd8Rbr7eoJM%3D",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-110dc77c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/home.vue
// module id = 41
// module chunks = 0